import { inject } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSerializer,
  UrlTree,
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
} from '@angular/router'
import { AuthService } from '@app/modules/auth/auth.service'
import { merge, Observable, of } from 'rxjs'
import { filter, first, switchMap } from 'rxjs/operators'

export const termsGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService)
  const urlSerializer = inject(UrlSerializer)

  authService.redirectUrl = state.url

  const termsAccepted$ = authService.termsAccepted$

  const canActivate$ = termsAccepted$.pipe(filter(Boolean)) as Observable<boolean>

  const termsNotAccepted = (termsAccepted) => !termsAccepted
  const redirectToTerms = () => of(urlSerializer.parse('/terms-of-use'))
  const cannotActivate$ = termsAccepted$.pipe(filter(termsNotAccepted), switchMap(redirectToTerms))

  return merge(canActivate$, cannotActivate$).pipe(first())
}

export const termsChildGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return termsGuard(route, state)
}

export const termsMatchGuard: CanMatchFn = (route, segments): Observable<boolean> => {
  const authService = inject(AuthService)
  return authService.termsAccepted$.pipe(first())
}
